/**
 * Флаги внешних порталов (desk_show_portal_*) — только явное включение в админке.
 * Не использовать общий deskOn(...), где undefined = true.
 */
export function deskPortalOn(p: Record<string, boolean> | null | undefined, key: string): boolean {
  if (!p) return false
  return Boolean(p[key])
}
